// className recognized by Google Docs, reference: https://stackoverflow.com/a/51704440
export const PageBreak = () => {
    return (
        <>
            <hr className="pb" />
            <br />
        </>
    );
};